import { Grid, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useDispatch } from "react-redux";
import Pagination from "./Pagination";
import { logEvent } from "../../utils/Analytics";
import urlText from "../urlText";
import { loadUser } from "../../actions/userActions";

function EmployerDetail() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const itemsPerPage = 15;

    const [teamData, setTeamData] = useState([]);
    const [search, setSearch] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);

    // ---------------- SEARCH ----------------
    const handleChange = (e) => {
        setSearch({ ...search, [e.target.name]: e.target.value });
        setCurrentPage(1);
    };

    // ---------------- LOAD USER ----------------
    useEffect(() => {
        dispatch(loadUser());
    }, []);

    // ---------------- RESET PAGINATION ----------------
    useEffect(() => {
        if (location.state?.resetPagination) {
            setCurrentPage(1);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    // ---------------- API CALL ----------------
    const getData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(
                `/api/user/getemployerdata?page=${currentPage}&limit=${itemsPerPage}`,
                { search }
            );
            console.log(data);
            setTeamData(data?.data || []);
            setPageCount(data?.pagination?.totalPages || 1);
        } catch (error) {
            console.log("Server error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
        window.scrollTo(0, 0);
    }, [currentPage, search]);

    const handleAddEvent = (str, item) => {
        console.log(item);
        // logEvent("Button", `Clicked ${str}`);
        navigate(
            `/company-detail/${urlText(item.organisationName)}`,
            {
                state: {
                    organisationName: item.organisationName,
                    organisationURL: item.organisationURL,
                    employerIds: item.ids,
                    activeJobCount: item.activeJobCount,
                },
            }
        );
    };

    // ---------------- UI ----------------
    return (
        <div className="py-4" style={{ backgroundColor: "rgba(224,220,243,0.2)" }}>
            {/* TITLE */}
            <Grid container justifyContent="center" mt={5} mb={4}>
                <h2
                    style={{
                        background: "#fff",
                        borderRadius: "10px",
                        padding: "10px 80px",
                    }}
                >
                    Employer Details
                </h2>
            </Grid>

            <div
                style={{
                    background: "#fff",
                    borderRadius: "10px",
                    margin: "0 auto 50px",
                    maxWidth: "1050px",
                    width: "85%",
                    position: "relative"
                }}
            >

                <Grid
                    container
                    sx={{
                        background: "#4B92C8",
                        color: "#fff",
                        fontWeight: 500,
                        borderRadius: "10px 10px 0 0",
                        py: 1,
                    }}
                >
                    <Grid item xs={7} textAlign="start" pl={8}>
                        Company Name
                    </Grid>
                    <Grid item xs={5} textAlign="end" pr={15}>
                        Actions
                    </Grid>
                </Grid>

                <Grid container py={2}>
                    <Grid item xs={12} pl={8}>
                        <Form.Control
                            placeholder="Search Company"
                            name="name"
                            value={search.name || ""}
                            onChange={handleChange}
                            style={{
                                maxWidth: "400px",
                                height: "44px",
                                fontSize: "15px",
                                padding: "10px 14px",
                            }}
                        />

                    </Grid>
                </Grid>

                <hr style={{ margin: 0 }} />

                {loading ? (
                    <Grid container justifyContent="center" py={4}>
                        <ScaleLoader color="#4B92C8" />
                    </Grid>
                ) : (
                    <>
                        {/* DATA */}
                        {teamData.length > 0 ? (
                            teamData.map((item, index) => (
                                <div key={item.ids.join("-")}>
                                    <Grid container alignItems="center" py={1}>
                                        <Grid item xs={7} pl={8}>
                                            {item.organisationName}
                                        </Grid>
                                        <Grid item xs={4} textAlign={"end"}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                sx={{
                                                    background: "#4B92C8",
                                                    textTransform: "none",
                                                    borderRadius: "6px",
                                                    "&:hover": {
                                                        background: "#3b7bb0",
                                                    },
                                                    fontSize: { xs: "12px", md: "14px" },
                                                    padding: { xs: "6px 16px", md: "8px 22px" },
                                                }}
                                                onClick={() => {
                                                    handleAddEvent("View More", item);
                                                }}
                                            >
                                                View More
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <hr style={{ margin: 0 }} />
                                </div>
                            ))
                        ) : (
                            <Grid container justifyContent="center" py={4}>
                                No Employers Found
                            </Grid>
                        )}
                    </>
                )}
                {pageCount > 1 && (
                    <div
                        style={{
                            position: "absolute",
                            bottom: "-60px",
                            maxWidth: "1200px",
                            width: "100%",
                            paddingBottom: "5px",
                            margin: "auto 0",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Pagination
                            totalPages={pageCount}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </div>
                )}
            </div>

            {/* PAGINATION */}

        </div>
    );
}

export default EmployerDetail;
